import React from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './LoadingState.scss';

interface LoadingStateProps {
  message?: string;
  fullScreen?: boolean;
  iconSize?: number;
  iconColor?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ 
  message,
  fullScreen = false,
  iconSize = 32, // Increased default size
  iconColor
}) => {
  const { t } = useTranslation();
  const style = iconColor ? { color: iconColor } : {};
  
  return (
    <div className={`loading-state ${fullScreen ? 'fullscreen' : ''}`}>
      <Loader2 className="loading-icon" size={iconSize} style={style} />
      <p className="loading-message">{message ?? t('common.loadingDots')}</p>
    </div>
  );
};

export default LoadingState; 